import React , { useState , useEffect}  from "react" ;
 

import { queryClient } from '../../../state/queryClient';
import { useCourtier } from "../../../state/reactquery";

import { axios_cabinetscompagnies_registerappellation } from "../../../axios/axios_cabinetscompagnies";
import { changeGrouperoleAuth } from "../utils";
import { axios_gammesnew_getallgammes } from "../../../axios/axios_gammesnew";
 

import './TabloOneCompagnie.scss';
const ROLES = ['COMMERCIAL','MANAGER','GESTION','ADMIN'];
const classNames = require('classnames');

// mdp https://www.gov.il/
// Talia2009!

function InputLibelle({compagnie_mini,gamme_mini,type_tarif}){
    const {data:courtier}  = useCourtier() ; 
    const jsonauths  = courtier?.autorisation||{} ;


    const [libelle, setLibelle] = useState('') ;

    useEffect(()=>{
        const libelleactu = jsonauths[compagnie_mini]?.['gammes']?.[gamme_mini]?.['tarifs']?.[type_tarif]?.['appellation'] ;
        setLibelle(libelleactu)
    },[courtier?.autorisation]);

    const registerappellationMemo=async(value_appellation)=>{
        let copyauths=  {...jsonauths} ;
        copyauths[compagnie_mini]['gammes'][gamme_mini]['tarifs'][type_tarif]['appellation']= value_appellation ;
        await axios_cabinetscompagnies_registerappellation({'courtier':courtier?.nomdomaine,'autorisation':copyauths});
        queryClient.invalidateQueries({ queryKey: ['courtier']})  ;
   }


   const registerappellation = async (value_appellation) => {
    // 1. Copie profonde pour éviter de modifier l'état original directement
    let copyauths = JSON.parse(JSON.stringify(jsonauths));

    // 2. Vérification et création sécurisée de chaque niveau
    if (!copyauths[compagnie_mini]) copyauths[compagnie_mini] = { gammes: {} };
    if (!copyauths[compagnie_mini].gammes) copyauths[compagnie_mini].gammes = {};
    if (!copyauths[compagnie_mini].gammes[gamme_mini]) copyauths[compagnie_mini].gammes[gamme_mini] = { tarifs: {} };
    if (!copyauths[compagnie_mini].gammes[gamme_mini].tarifs) copyauths[compagnie_mini].gammes[gamme_mini].tarifs = {};
    if (!copyauths[compagnie_mini].gammes[gamme_mini].tarifs[type_tarif]) {
        copyauths[compagnie_mini].gammes[gamme_mini].tarifs[type_tarif] = {};
    }

    // 3. Assignation de la valeur
    copyauths[compagnie_mini].gammes[gamme_mini].tarifs[type_tarif].appellation = value_appellation;

    // 4. Appel API et refresh
    await axios_cabinetscompagnies_registerappellation({
        courtier: courtier?.nomdomaine,
        autorisation: copyauths
    });
    
    queryClient.invalidateQueries({ queryKey: ['courtier'] });
};

    return(<input type='text' className="tablogammes_tablo_input"
                 value={libelle}  
                 onChange={(e)=>{setLibelle(e.target.value)}} 
                 onBlur={(e)=>{registerappellation(e.target.value)}}  />)
}


function TabloOneCompagnie({compagnie_mini}){
    const {data:courtier}  = useCourtier() ; 
    const [actuauths, setActuauths] = useState() ;
    const [jsonallgammes, setJsonallgammes]=useState({})  ;
    
    useEffect(()=>{setActuauths(courtier?.autorisation||{} )},[courtier?.autorisation]) ;
      
    const gammes = jsonallgammes?.[compagnie_mini]?.['gammes'] || [] ;

    //DEV AXIOS
    async function fetchGammes() { 
        const res = await axios_gammesnew_getallgammes();
        const gammesfetch = res.data?.filter(x=>x.type_tarif!=='no') ; 
        let jsongamme={} ;

        for(let datasgamme of gammesfetch){
            const {compagnie,gamme,compagnie_mini,gamme_mini,type_tarif} = datasgamme ;
            if(!jsongamme.hasOwnProperty(compagnie_mini)){
                jsongamme[compagnie_mini]={}; 
                jsongamme[compagnie_mini]["nom_compagnie"]=compagnie ;
                jsongamme[compagnie_mini]["gammes"]={} ;
            }  
            jsongamme[compagnie_mini]["gammes"][gamme_mini]={'nom_gamme':gamme,'tarifs':type_tarif}   
        }
        setJsonallgammes(jsongamme) ;
    } 

    useEffect(()=>{fetchGammes() ; },[]) ;


    

    const changegreoupeauthMemo = async({compagnie_mini,gamme_mini,type_tarif,ROLE})=>{    
         const actuauthsvalue = actuauths?.[compagnie_mini]?.['gammes'][gamme_mini]?.['tarifs'][type_tarif]?.['autorisations']?.[ROLE] ;
        const newvalue = actuauthsvalue===1?0:1 ;
        await changeGrouperoleAuth({courtier:courtier?.nomdomaine,actuauths,compagnie_mini,gamme_mini,type_tarif,ROLE,newvalue}) ;
        queryClient.invalidateQueries({ queryKey: ['courtier'] });
   }


   const changegreoupeauth = async({compagnie_mini, gamme_mini, type_tarif, ROLE}) => {    
    // Ajout du ?. partout pour éviter de lire une propriété sur undefined
    const actuauthsvalue = actuauths?.[compagnie_mini]?.['gammes']?.[gamme_mini]?.['tarifs']?.[type_tarif]?.['autorisations']?.[ROLE];
    
    // On définit newvalue (si actuauthsvalue est undefined ou 0, on met 1, sinon 0)
    const newvalue = actuauthsvalue === 1 ? 0 : 1;

    await changeGrouperoleAuth({
        courtier: courtier?.nomdomaine,
        actuauths, 
        compagnie_mini, 
        gamme_mini, 
        type_tarif, 
        ROLE, 
        newvalue
    });

    queryClient.invalidateQueries({ queryKey: ['courtier'] });
}



    const typetarifgamme=(index,compagnie_mini,gamme_mini,type_tarif)=>{
        const autorisations =  actuauths?.[compagnie_mini]?.['gammes']?.[gamme_mini]?.['tarifs']?.[type_tarif]?.['autorisations'];

        const nom_compagnie =jsonallgammes[compagnie_mini].nom_compagnie ;
        const nom_gamme = jsonallgammes[compagnie_mini]['gammes'][gamme_mini].nom_gamme;

        return(<> {actuauths?<div className="tablogammes_tablo_line" >
                                        <div>{index===0 && nom_compagnie}</div>
                                        <div>{index===0 && nom_gamme}</div>
                                        <div>{type_tarif}</div>
                                        <div><InputLibelle compagnie_mini={compagnie_mini} gamme_mini={gamme_mini} type_tarif={type_tarif}  /></div>
                                        {ROLES.map(ROLE=>(<div key={ROLE} 
                                                                className={classNames({"isselected":autorisations?.[ROLE]===1}, {"noselected":autorisations?.[ROLE]!==1})}
                                                                onClick={()=>changegreoupeauth({compagnie_mini,gamme_mini,type_tarif,ROLE})}>
                                                            </div>))} 
                            </div>:<></>}</>)  
    }

    const gamme=(compagnie_mini,gamme_mini)=>{
        const tarifs = jsonallgammes[compagnie_mini]['gammes'][gamme_mini]['tarifs'] ; 
        return(<div key={gamme_mini}>
                    {tarifs?.split(',').map((tarif,index)=><div key={index}>{typetarifgamme(index,compagnie_mini,gamme_mini,tarif)}</div> )}
                </div>)
    }

    return(<><div className="tablogammes_tablo bigtablo">
                <div className="tablogammes_tablo_line1" >
                    <div>Compagnie</div><div>Gamme</div><div>Tarification</div><div>Appellation</div>
                    <div>Conseiller</div><div>Manager</div><div>Gestion</div><div>Admin</div>
                </div>
                <div className="tablogammes_tablo_lines overflowyscroll">
                    {Object.keys(gammes).map((gamme_mini)=>gamme(compagnie_mini,gamme_mini))}
                </div>
            </div><br/><br/><br/></>)

}

export default TabloOneCompagnie


